import { CountUp } from 'countup.js';

export function init() {
  const elements = document.querySelectorAll('[data-js-count]');

  [...elements].forEach((element) => {
    element.addEventListener('sal:in', ({ detail }) => {
      const target = detail.target.getAttribute('data-js-count')
        ? detail.target.getAttribute('data-js-count')
        : '';
      const suffix = detail.target.getAttribute('suffix')
        ? detail.target.getAttribute('suffix')
        : '';

      const countUp = new CountUp(detail.target, target, {
        separator: ',',
        duration: 2.5,
        suffix: suffix,
      });

      if (!countUp.error) {
        countUp.start();
      }
    });
  });
}
